module.exports = __webpack_public_path__ + "static/media/gmlc.bffd6c39.png";